import {
  UPDATE_AE_REGION,
  UPDATE_AE_REGION_SELECTION,
  FETCH_AE_REGION,
  FETCH_AE_REGION_START,
  FETCH_AE_REGION_SUCCESS,
  FETCH_AE_REGION_ERROR,
  FETCH_AE_REGION_SELECTION,
  FETCH_AE_REGION_SELECTION_START,
  FETCH_AE_REGION_SELECTION_SUCCESS,
  FETCH_AE_REGION_SELECTION_ERROR,
  POST_AE_REGION,
  POST_AE_REGION_START,
  POST_AE_REGION_SUCCESS,
  POST_AE_REGION_ERROR,
} from './constants'

const updateAeRegion = (regions) => ({ type: UPDATE_AE_REGION, regions })
const updateAeRegionSelection = (regions) => ({ type: UPDATE_AE_REGION_SELECTION, regions })

const fetchAeRegion = (projectId) => ({ type: FETCH_AE_REGION, projectId })
const fetchAeRegionStart = () => ({ type: FETCH_AE_REGION_START })
const fetchAeRegionSuccess = () => ({ type: FETCH_AE_REGION_SUCCESS })
const fetchAeRegionError = (error) => ({ type: FETCH_AE_REGION_ERROR, error })

const fetchAeRegionSelection = () => ({ type: FETCH_AE_REGION_SELECTION })
const fetchAeRegionSelectionStart = () => ({ type: FETCH_AE_REGION_SELECTION_START })
const fetchAeRegionSelectionSuccess = () => ({ type: FETCH_AE_REGION_SELECTION_SUCCESS })
const fetchAeRegionSelectionError = (error) => ({ type: FETCH_AE_REGION_SELECTION_ERROR, error })

const postAeRegion = (projectId) => ({ type: POST_AE_REGION, projectId })
const postAeRegionStart = () => ({ type: POST_AE_REGION_START })
const postAeRegionSuccess = () => ({ type: POST_AE_REGION_SUCCESS })
const postAeRegionError = (error) => ({ type: POST_AE_REGION_ERROR, error })

export {
  updateAeRegion,
  updateAeRegionSelection,
  fetchAeRegion,
  fetchAeRegionStart,
  fetchAeRegionSuccess,
  fetchAeRegionError,
  fetchAeRegionSelection,
  fetchAeRegionSelectionStart,
  fetchAeRegionSelectionSuccess,
  fetchAeRegionSelectionError,
  postAeRegion,
  postAeRegionStart,
  postAeRegionSuccess,
  postAeRegionError,
}
